import type { ReactNode } from 'react';

interface SectionHeadingProps {
  no: string;
  title: string;
  en?: string;
  desc?: string;
  right?: ReactNode;
  tone?: 'default' | 'light';
}

export default function SectionHeading({
  no,
  title,
  en,
  desc,
  right,
  tone = 'default',
}: SectionHeadingProps) {
  const isLight = tone === 'light';
  return (
    <div
      className={`mb-6 flex flex-wrap items-end justify-between gap-x-6 gap-y-3 border-b pb-4 md:mb-8 ${
        isLight ? 'border-background-50/15' : 'border-background-300'
      }`}
    >
      <div className="flex items-end gap-3 md:gap-4">
        <span className="font-label text-3xl leading-none text-primary-500 md:text-4xl">
          {no}
        </span>
        <span
          className={`mb-1 h-8 w-px ${isLight ? 'bg-background-50/25' : 'bg-background-300'}`}
        />
        <div>
          <div className="flex items-baseline gap-2">
            <h2
              className={`font-heading text-xl font-black tracking-tight md:text-2xl ${
                isLight ? 'text-background-50' : 'text-foreground-950'
              }`}
            >
              {title}
            </h2>
            {en && (
              <span
                className={`font-label text-[11px] uppercase tracking-[0.2em] ${
                  isLight ? 'text-background-50/50' : 'text-foreground-400'
                }`}
              >
                {en}
              </span>
            )}
          </div>
          {desc && (
            <p
              className={`mt-1 text-xs md:text-sm ${
                isLight ? 'text-background-100/70' : 'text-foreground-600'
              }`}
            >
              {desc}
            </p>
          )}
        </div>
      </div>
      {right}
    </div>
  );
}